import React from 'react';
import { Row, Image } from 'modules/styled';

const iosLink = 'https://itunes.apple.com/us/app/relevant-communities/id1173025051?mt=8';
const googlePlay =
  'https://play.google.com/store/apps/details?id=com.relevantnative&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';

const iosImg = '/img/appstore.png';
const googleImg = '/img/googleplaystore.png';

const AppStoreButtons = ({ sx }) => (
  <Row sx={{ mt: [4, 8], mb: [1, 0], ...sx }}>
    <a href={iosLink} rel="noreferrer" target="_blank">
      <Image
        sx={{ height: [6, 7], width: [6 * 8 * 2.8, 7 * 8 * 2.8], mr: [1, 2] }}
        resizeMode="contain"
        source={{ uri: iosImg }}
      />
    </a>
    <a href={googlePlay} rel="noreferrer" target="_blank">
      <Image
        sx={{ height: [6, 7], width: [6 * 8 * 3, 7 * 8 * 3] }}
        resizeMode="contain"
        source={{ uri: googleImg }}
      />
    </a>
  </Row>
);

export default AppStoreButtons;
